import React, { forwardRef } from 'react'
import { Input } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type AntdFormTextAreaProps = React.ComponentProps<typeof Input.TextArea> & {
  //
} & AntdFormItemProps

export const AntdFormTextArea: React.FC<AntdFormTextAreaProps> = forwardRef(({
  fieldProps,
  className,
  ...props
}, ref) => {
  return (
    <AntdFormItem {...fieldProps}>
      <Input.TextArea ref={ref} {...props} className={cn('w-full', className)} rows={props.rows ?? 4} />
    </AntdFormItem>
  )
})